import { PlatformError } from '@djgg/core';
import type { BuildJob } from './types.js';

/** Forward-only admission: historical published games and receipts remain valid. */
export const GENERIC_CREATION_RETIRED = 'The previous AI creation and editing pipeline is retired. Your published game and saved work remain available. Start a new game: Create builds it from the platform\'s reusable parts. Editing, repairing or republishing older generated games is unavailable until the replacement editor is ready.';

/** A composed game is current, not retired: only rule edits are not offered yet. */
export const COMPOSED_RULES_EDITING_UNAVAILABLE = 'Changing the rules of a composed game is not available yet. Your game stays playable: you can replace its artwork in Assets, make a copy, or start a new game with Create.';

export function requireCompositionBuildJob(job: Pick<BuildJob, 'requiredWorkerCapability' | 'measuredExecution'>): void {
  // These markers select the existing authenticated Composition executors;
  // they do not replace their authority, digest, claim or proof validation.
  if (job.requiredWorkerCapability === 'composition-private-v2' && job.measuredExecution?.compositionV2Acceptance
    || job.measuredExecution?.compositionDigest) return;
  throw new PlatformError('validation', GENERIC_CREATION_RETIRED);
}
